import React from 'react';
import { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import * as httpService from '../../services/HTTPService';
// import { redirect } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { useAuth } from '../../context/authContext';
import SpinLoader from '../spin-loader';
import { hideOverlay } from '../../utils/utils';
import "react-day-picker/style.css";
// type GoogleLoginProp = GoogleLoginProps & {
//     className?: any
// }

function AppointmentForm(props: any) {
  const { t, i18n } = useTranslation();  
  const sendLbl = i18n.exists("forms.send") ? t('forms.send') : "Изпрати";
  const namesLbl = i18n.exists("forms.names") ? t('forms.names') : "Имена";
  const messageLbl = i18n.exists("forms.message") ? t('forms.message') : "Съобщение"; 
  const [visibleErrors, setVisibleErrors] = useState(true);
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();
  const defaultFormData = {
    email: "",
    names: "",
    message: ""
  }
  let [conactForm, setContactForm] = useState(defaultFormData);
  let [isSpinning, setIsSpinning] = useState(false);

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    setVisibleErrors(true);
    event.preventDefault();
    event.stopPropagation();
    const form: any = event.currentTarget;
    let contactData: any  = {...conactForm};
    const data:any = new FormData(event.currentTarget);
    //let formObject = Object.fromEntries(data.entries())
    let d = data.entries();
    for (let [key, value] of d) {
        contactData[key] = value;
        if(key === 'phone') {
            setPhone(value);
        }
        if(key === 'email') {
            setEmail(value);
        }
        if(key === 'names') {
            setUserName(value);
        }
        //console.log(key, value);
    }
    if(form[2].id === "message") {
        contactData['message'] = form[2].value;
    }
    
    conactForm = contactData;
    setContactForm(contactData);
    props.formData({
        email: email,
        fullName: userName,
        phoneNumber: phone
    });
    if (form.checkValidity() === true) {
        props.isValidForm(true);
        setValidated(true);
    }
    else {
        props.isValidForm(false);
        setValidated(false);
    }
    
  };

  const resetForm = (form: any) => {
    form.reset();
    setVisibleErrors(false);
    setValidated(false);

  }

  useEffect(() => {
    const user: any = localStorage.getItem('auth-user');
    const authUser = JSON.parse(user);
    const names = authUser.firstName && authUser.lastName ? authUser.firstName + " " + authUser.lastName : "";
    setPhone(authUser.phone);
    setEmail(authUser.email);
    setUserName(names);
    props.formData({
        email: authUser.email,
        fullName: names,
        phoneNumber: authUser.phone
    });
    props.isValidForm(true);
}, [])

  const sendMessage = (data: any) => {
    //setIsSpinning(true);
    toast.success('Вашето съобщение е изпратено успешно!');
    console.log(data);
    // TODO: create a new sendMessage api method and uncomment this code:
    // httpService.sendMessage(JSON.stringify(data)).then((res) => {
    //     if(res) {
    //         //console.log(res);
    //         toast.success('Вашето съобщение е изпратено усешно!');
    //         hidePreloader();
    //     }
    // })
    // .catch((err) => {
    //     console.log(err);
    //     hidePreloader();
    //     toast.error(t('forms.commonErrMsg'));
    // })
  }

    const hidePreloader = () => {
        hideOverlay();
        setIsSpinning(false);
    }

  return (
    <div>
        <ToastContainer position="top-center"
 />
        <Form id="contact-form" noValidate validated={validated} onSubmit={handleSubmit} onChange={handleSubmit}>
            <Row>
                <Form.Group as={Col} md="4" controlId="email">
                    <Form.Label>{t('forms.email')}*</Form.Label>
                    <Form.Control 
                        type="email"
                        name="email"
                        required={visibleErrors}
                        value={email}
                    />
                   <Form.Control.Feedback type="invalid">
                        {t('forms.validEmailError')}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} md="4" controlId="names">
                    <Form.Label>{namesLbl}*</Form.Label>
                    <Form.Control 
                        type="text"
                        name="names"
                        required={visibleErrors}
                        value={userName}
                    />
                     <Form.Control.Feedback type="invalid">
                            {t('forms.requiredFieldError', { field: namesLbl})}
                        </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="4" controlId="phone">
                    <Form.Label>{t('forms.phone')}*</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        name="phone"
                        value={phone}
                    />
                    <Form.Control.Feedback type="invalid">
                            {t('forms.requiredFieldError', { field: t('forms.phone')})}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
        </Form>
        {isSpinning ? (
            <SpinLoader />
        ) : null}
    </div>
  );
}

export default AppointmentForm;